module.exports = __webpack_public_path__ + "img/524c98e.png";